import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Breadcrumb, Select, Menu, Form, Button, Statistic} from 'semantic-ui-react';
import {Helmet} from "react-helmet";
import connect from "react-redux/es/connect/connect";
import moment from 'moment';

import CustomDivider from '../../components/extras/CustomDivider';
import AlertUpgrade from "../../components/extras/AlertUpgrade";
import localDB from "../../data/localDB";
import UpgradeAccount from "../../components/extras/UpgradeAccount";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import BranchOfficeData from "../../data/BranchOfficeData";
import SimpleTable from "../../components/extras/SimpleTable";
import {FormattedNumber} from "react-intl";
import {simpleTableList} from "../../actions/SimpleTableDataActions";
import Auth from "../../data/auth";

let GLOBAL = require('../../data/globals');


class ReportDate extends Component {
    render() {
        return moment(this.props.date).format('DD MMMM [de] YYYY');
    }
}

class ReportIncome extends Component {

    constructor(props) {
        super(props);

        this.state = {
            branch_offices: [],
            branch_office: {
                id: '',
                name: ''
            },
            table: {
                headers: ['Fecha', 'Impuestos', 'Ingresos'],
                title: 'Reporte de Ingresos',
                has_actions: false,
                edit: false,
                delete: false,
                url: `reports/income?branch_office=${localDB.get('branch_office')}&start_date=${moment(Date.now()).format("YYYY-MM-DD")}&end_date=${moment(Date.now()).format("YYYY-MM-DD")}&`,
                values: ['id', 'date', 'taxes', 'total'],
                money_fields: ['total', 'taxes'],
                component_fields: [{date:ReportDate}],
                id: 'table_sales_range'
            },
            start_date:  moment(Date.now()).format("YYYY-MM-DD"),
            end_date: moment(Date.now()).format("YYYY-MM-DD"),
            date_start_error: false,
            date_end_error: false,
            total: null,
            loading: false,
            downloading: false
        };
    }

    componentDidMount() {
        this.getBranchOffices();
    }

    async getBranchOffices() {
        let branch_offices = await BranchOfficeData.listAll();
        this.setState({branch_offices});
        this.handleBranchOfficeChange(branch_offices[0].key)
    }

    handleBranchOfficeChange = (result) => {
        this.setState({branch_office: {id: result, name: result}});
    };

    handleStartDateClick = (selectedDay) => {
        let start_date = moment(selectedDay).format("YYYY-MM-DD");
        this.setState({date_start_error: false, start_date});
    };

    handleEndDateClick = (selectedDay) => {
        let end_date = moment(selectedDay).format("YYYY-MM-DD");
        this.setState({date_end_error: false, end_date});
    };

    handleSubmit = () => {
        if(!this.state.start_date){
            this.setState({date_start_error:true})
        }else if(!this.state.end_date){
            this.setState({date_end_error:true})
        }else{
            this.setState({
                loading: true,
                table: {
                    headers: ['Fecha', 'Impuestos', 'Ingresos'],
                    title: 'Reporte de Ingresos',
                    has_actions: false,
                    edit: false,
                    delete: false,
                    url: `reports/income?branch_office=${this.state.branch_office.id}&start_date=${this.state.start_date}&end_date=${this.state.end_date}&`,
                    values: ['id', 'date', 'taxes', 'total'],
                    money_fields: ['total', 'taxes'],
                    component_fields: [{date:ReportDate}],
                    id: 'table_sales_range'
                },
            })
        }
    };

    returnData = (data) =>{
        let total = data.reduce((a, b) => +a + +b.total, 0);
        this.setState({total, loading:false});
    };

    downloadReport = () =>{
        this.setState({downloading:true});
        Auth.tokenUID().then(res => {
            if(res.token){
                let link =   document.createElement("a");
                link.download = 'download';
                link.href = `${GLOBAL.BASE_URL}api/reports/income/excel?token=${res.token}&uid=${res.uid}&branch_office=${this.state.branch_office.id}&start_date=${this.state.start_date}&end_date=${this.state.end_date}&`;
                link.click();
            }
        }).catch((error) => console.log(error))
            .finally(() => { this.setState({downloading:false}); });
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Reporte de Ingresos - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/reports'>Informes</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Reporte de Ingresos</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                {!localDB.checkPlanAccessExclude('reports_view_all') ? <div>
                    <Menu secondary>
                        <Menu.Menu>
                            <Menu.Item>
                                <Form>
                                    <Form.Group inline>
                                        <Form.Field>
                                            <label>Sucursal:</label>
                                            <Select options={this.state.branch_offices}
                                                    onChange={(e, {value}) => this.handleBranchOfficeChange(value)}
                                                    value={this.state.branch_office.id} placeholder='Sucursal'
                                                    error={this.state.branch_office_error} width={4}/>
                                        </Form.Field>
                                        <label>Desde:</label>
                                        <Form.Field error={this.state.date_start_error}>
                                            <DayPickerInput readOnly placeholder="MM/DD/YYYY" format="MM/DD/YYYY"
                                                            value={this.state.start_date}
                                                            onDayChange={this.handleStartDateClick}
                                                            onChange={this.handleStartDateClick}/>
                                        </Form.Field>
                                        <label>Hasta:</label>
                                        <Form.Field error={this.state.date_end_error}>
                                            <DayPickerInput readOnly placeholder="YYYY-MM-DD" format="YYYY-MM-DD"
                                                            value={this.state.end_date}
                                                            onDayChange={this.handleEndDateClick}
                                                            onChange={this.handleEndDateClick}/>
                                        </Form.Field>
                                        <Button icon='search' labelPosition='left' primary content="Consultar" loading={this.state.loading} disabled={this.state.loading}  onClick={this.handleSubmit}/>
                                        <Button icon='download' labelPosition='left' content="Descargar" onClick={this.downloadReport} loading={this.state.downloading} disabled={this.state.downloading}/>
                                    </Form.Group>
                                </Form>
                            </Menu.Item>
                        </Menu.Menu>
                    </Menu>
                    {this.state.total ? <div style={{textAlign:'center'}}>
                        <Statistic>
                            <Statistic.Value>
                                $<FormattedNumber value={this.state.total} currency="USD" maximumFractionDigits={1}
                                                 minimumFractionDigits={1}/>
                            </Statistic.Value>
                            <Statistic.Label>{`Ingresos desde ${moment(this.state.start_date).format('DD MMMM [de] YYYY')} hasta ${moment(this.state.end_date).format('DD MMMM [de] YYYY')}`}</Statistic.Label>
                        </Statistic>
                    </div>:null}

                    <SimpleTable {...this.state.table} return_data={true} callbackReturnData={this.returnData}/>
                </div>:<UpgradeAccount/>}
                <AlertUpgrade ref='alert_upgrade' />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        simpleTableList(data) {
            dispatch(simpleTableList(data))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(ReportIncome)



// WEBPACK FOOTER //
// ./src/containers/reports/ReportIncome.js